module.exports = __webpack_public_path__ + "static/media/hint.7a21f467.svg";